import React from "react";
import { Stack, Switch, Checkbox, TextField, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { InputControl } from "../../../shared";

export const CategoryTaggingSection = ({
  tipsAndTricks,
  onChange,
  onDeleteCategorySelect,
  CategoryOptions,
}) => (
  <Stack gap="16px">
    <Switch
      name="category_type"
      checked={tipsAndTricks.category_type === 1}
      onChange={(e) => onChange(e, "category_type")}
      edge="start"
    />
    {tipsAndTricks?.category_type === 1 && (
      <Stack spacing={2}>
        <InputControl
          type="dropdown"
          name="category_id"
          multiple
          options={CategoryOptions ?? []}
          value={CategoryOptions?.filter((op) =>
            tipsAndTricks?.data?.category_id?.some(
              (item) => item?.id === op?.id
            )
          )}
          disableCloseOnSelect
          disableClearable
          onChange={(e, v) =>
            onChange({
              target: {
                name: "category_id",
                value: v,
              },
            })
          }
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.id}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option.name}
            </li>
          )}
          filterOptions={(options, { inputValue }) =>
            options.filter((option) =>
              option.name.toLowerCase().includes(inputValue.toLowerCase())
            )
          }
          sx={{ width: 255 }}
          componentsProps={{
            paper: {
              sx: {
                width: "100%",
                minWidth: 250,
              },
            },
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => <></>)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Type or Select Categories"
              placeholder="Type or Select Categories"
            />
          )}
        />
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          gap="12px"
          mt={1}
        >
          {(tipsAndTricks?.data?.category_id ?? []).map((data, index) => (
            <Chip
              key={index}
              variant="outlined"
              label={data?.name}
              deleteIcon={<CloseIcon />}
              onDelete={() => onDeleteCategorySelect(data)}
              sx={{
                "& .MuiChip-deleteIcon": {
                  color: "#CCCCCC",
                },
              }}
            />
          ))}
        </Stack>
      </Stack>
    )}
  </Stack>
);
